<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="服务网点" prop="nursinghomeId">
              <el-select
                disabled
                v-model="form.nursinghomeId"
                style="width: 100%"
                placeholder="请选择服务网点"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in nursinghomeIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="主题" prop="theme"> 
              <el-input
              :disabled="model === 'view'"
                clearable
                v-model="form.theme"
                placeholder="请输入主题"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动时间" prop="eventsTime"> 
              <el-date-picker 
              :disabled="model === 'view'"
                style="width: 100%;" 
                value-format="yyyy-MM-dd HH:mm:ss" 
                v-model="form.eventsTime" 
                type="datetime" 
                placeholder="请选择活动时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动地点" prop="location"> 
              <el-input
              :disabled="model === 'view'"
                clearable
                v-model="form.location"
                placeholder="请输入活动地点"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动人员" prop="elderlyIds"> 
              <el-select
              :disabled="model === 'view'" v-model="form.elderlyIds_" multiple style="width: 100%" placeholder="请选择活动人员">
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="描述" prop="description">
              <el-input
              :disabled="model === 'view'" v-model="form.description" maxlength="300" type="textarea" placeholder="请输入描述" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
  <script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import {
  getMatetial,
  getTotalWarehouseWarnSetting,
  stockWarnSave,
  getWarehouseWarnSetting,
  getNursinghome,
  getNursingList,
  saveEvents,
  updateEvents,
  getEventsDetail
} from '../api/serveItemManage';
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],

      form: {
        nursinghomeId: '',
        downWarnValue: '',
        upWarnValue: '',
        projectType:2,
      },
      formRules: {
        nursinghomeId: [{ required: true, message: '服务网点不能为空', trigger: 'change' }],
        theme: [{ required: true, message: '主题不能为空', trigger: 'change' }],
        eventsTime: [{ required: true, message: '活动时间不能为空', trigger: 'change' }],
        location: [{ required: true, message: '活动地点不能为空', trigger: 'change' }],
      },
      matetialList: [],
      nursinghomeIdList: [],
      userList:[]
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    validate(val) {
      return (rule, value, callback) => {
        var reg = /^[0-9]{0,8}?$/;
        if (this.vdui.isNotEmpty(value)) {
          let flag = reg.test(value);
          if (!flag) {
            callback(new Error('请输入0-99,999,999的整数'));
          }
        }
        if (this.vdui.isNotEmpty(val) && this.vdui.isNotEmpty(value)) {
          if (Number(value) > Number(val)) {
            callback(new Error('下限不能大于上限'));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
    },
    validate2(val) {
      return (rule, value, callback) => {
        var reg = /^[0-9]{0,8}?$/;
        if (this.vdui.isNotEmpty(value)) {
          let flag = reg.test(value);
          if (!flag) {
            callback(new Error('请输入0-99,999,999的整数'));
          }
        }
        console.log(val, value);
        if (this.vdui.isNotEmpty(val) && this.vdui.isNotEmpty(value)) {
          if (Number(value) < Number(val)) {
            callback(new Error('上限不能小于下限'));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
    },
    consumableIdChange() {
      this.form.warehouseList = [];

      if (this.form.consumableId != '') {
        getWarehouseWarnSetting({
          nursinghomeId: this.form.nursinghomeId,
          type: '0',
          consumableId: this.form.consumableId,
        }).then((res) => {
          this.form = res.data;

          this.form.type = 0;
        });
      }
    },
    async initData() {
      if(this.model === 'add'){
      }else{
        getEventsDetail({id:this.row.id}).then(res=>{

          this.form = res.data;
          this.form.elderlyIds_ = res.data.elderlyIds.split(',');
        })
      }
          getNursingList({ id: this.nursinghomeId }).then((res) => {
            this.userList = res.data;
          });
      getProjectList().then((res) => {
        this.projectList = res.data;
      });
      getNursinghome({ id: this.nursinghomeId }).then(res=>{
        this.nursinghomeIdList = res.data;
        this.form.nursinghomeId = this.nursinghomeId;
      })
      if (this.model == 'add') {
        // this.form.nursinghomeId = this.nursinghomeId;
        // await getMatetial({ nursinghomeId: this.form.nursinghomeId }).then((res) => {
        //   this.matetialList = res.data;

        //   if (this.matetialList.length > 0) {
        //     this.form.consumableId = this.matetialList[0].id;
        //   }
        // });
        //通过物料id获取仓库数据
        // if (this.form.consumableId != '') {
        //   this.consumableIdChange();
        // }
      } else {
      }
    },
    saveRecord() {
      if(this.form.elderlyIds_&&this.form.elderlyIds_.length>0){

        this.form.elderlyIds = this.form.elderlyIds_.join(',');
      }
      if ((this.model === 'add')) {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            saveEvents(this.form).then((res) => {
              this.$message.success('操作成功');
              this.$emit('success');
            });
          }
        });
      }else{
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            updateEvents(this.form).then((res) => {
              this.$message.success('操作成功');
              this.$emit('success');
            });
          }
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
  